import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { FinanceAccountResponse } from "@/types";

async function fetchFinanceAccounts(
  page?: string | null,
  per_page?: number | null,
  search?: string | null
): Promise<FinanceAccountResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page}&search=${search ?? ""}`;
  const response = await httpRequest.get<FinanceAccountResponse>(
    `/finance-accounts?${pageParams}`
  );
  return response.data;
}

export function useFetchFinanceAccountsQuery({
  page,
  per_page,
  search,
}: {
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
}) {
  const accountsResponseQuery = useQuery({
    queryKey: ["accounts", page || "1", per_page, search],
    queryFn: () => fetchFinanceAccounts(page, per_page, search),
    keepPreviousData: true,
    enabled: true,
  });

  return {
    ...accountsResponseQuery,
    data: accountsResponseQuery?.data,
  };
}
